import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EventsService } from "../../../../components/events/event.service";
import { EditCouponUserInfoComponent } from "../../../../components/modal/edit-coupon-user-info/edit-coupon-user-info";

@Component({
  selector: "app-add-customer",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./add-customer.component.html",
  styleUrl: "./add-customer.component.scss",
})
export class AddCustomerComponent {
  @Input() token: string;

  constructor(private modalService: NgbModal, private eventService: EventsService) {}
  openModalInvite() {
    const modal = this.modalService.open(EditCouponUserInfoComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
    modal.componentInstance.modalType = "new";
    modal.result
      .then((result: any) => {
        this.eventService.emitEvent("refreshCustomer");
      });
  }

  isFile(result: any): boolean {
    if (result.size) {
      return true;
    } else return false;
  }
}
